export const CUSTOMER_KEY_ACTION = {
  CREATE_ANONYMOUS: 'create_anonymous',
  SET_INCOMING: 'set_incoming',
  SYNC_ENGAGE: 'sync_engage',
  NOOP: 'noop'
};

/** Pure decision logic for Elevate customerKey ↔ Engage discoveryKey sync. */
export function resolveCustomerKeyAction(currentKey, incomingKey) {
  const incoming = incomingKey != null ? String(incomingKey) : null;
  const current = currentKey != null ? String(currentKey) : null;

  if (!current && !incoming) {
    return { action: CUSTOMER_KEY_ACTION.CREATE_ANONYMOUS };
  }
  if (incoming && !current) {
    return { action: CUSTOMER_KEY_ACTION.SET_INCOMING, key: incoming };
  }
  if (incoming && current && incoming !== current) {
    return {
      action: CUSTOMER_KEY_ACTION.SYNC_ENGAGE,
      key: incoming,
      previousKey: current
    };
  }
  return { action: CUSTOMER_KEY_ACTION.NOOP, key: current };
}
